// services/bannerService.js
import axios from 'axios';

import { apiUrl } from './apiUrl';

const API_BASE_URL = '/Configuration'; // relative: used by axios

// Action Types
export const FETCH_BANNER_REQUEST = 'FETCH_BANNER_REQUEST';
export const FETCH_BANNER_SUCCESS = 'FETCH_BANNER_SUCCESS';
export const FETCH_BANNER_FAILURE = 'FETCH_BANNER_FAILURE';

// Action Creators
export const fetchBannerRequest = (positionID) => ({
  type: FETCH_BANNER_REQUEST,
  payload: { positionID }
});

export const fetchBannerSuccess = (positionID, imageUrl) => ({
  type: FETCH_BANNER_SUCCESS,
  payload: { positionID, imageUrl },
});

export const fetchBannerFailure = (positionID, error) => ({
  type: FETCH_BANNER_FAILURE,
  payload: { positionID, error },
});

// Helper function to detect if string is base64
const isBase64 = (str) => {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
};

// Thunk Action for fetching banner images
export const fetchBannerImage = (positionID) => {
  return async (dispatch) => {
    dispatch(fetchBannerRequest(positionID));
    
    try {
      console.log(`🔍 Fetching banner for ${positionID}...`);
      
      // First, try to fetch as text to see what we're getting
      const response = await axios.get(`${API_BASE_URL}/GetInterfaceImg`, {
        params: { positionID },
        responseType: 'text', // Get as text first to inspect
        transformResponse: [(data) => data] // Prevent axios from parsing
      });
      
      console.log('📥 Raw response:', response);
      console.log('📄 Raw data (first 200 chars):', response.data.substring(0, 200));
      
      let imageUrl = null;
      const data = response.data;
      
      // Case 1: It's already a complete data URL
      if (data.startsWith('data:image')) {
        console.log('✅ Found data URL image');
        imageUrl = data;
      }
      // Case 2: It's base64 without prefix
      else if (isBase64(data) || /^[A-Za-z0-9+/=]+$/.test(data)) {
        console.log('✅ Found base64 image');
        imageUrl = `data:image/jpeg;base64,${data}`;
      }
      // Case 3: It's a URL
      else if (data.startsWith('http')) {
        console.log('✅ Found HTTP URL');
        imageUrl = data;
      }
      // Case 4: It's a relative path
      else if (data.startsWith('/')) {
      console.log('✅ Found relative path');
      imageUrl = apiUrl(`Configuration${data}`);
    }
      // Case 5: It might be JSON string
      else {
        try {
          const jsonData = JSON.parse(data);
          console.log('📋 Parsed JSON:', jsonData);
          
          // Try common property names
          imageUrl = jsonData.imageUrl || 
                     jsonData.url || 
                     jsonData.image || 
                     jsonData.path ||
                     jsonData.data ||
                     jsonData.img ||
                     jsonData.src ||
                     jsonData.file ||
                     jsonData.content;
          
          if (imageUrl) {
            console.log('✅ Found image URL in JSON property');
          }
        } catch (e) {
          console.log('❌ Not JSON, trying as blob...');
          
          // Last resort: try fetching as blob
          try {
            const blobResponse = await axios.get(`${API_BASE_URL}/GetInterfaceImg`, {
              params: { positionID },
              responseType: 'blob'
            });
            
            if (blobResponse.data instanceof Blob && blobResponse.data.size > 0) {
              console.log('✅ Got blob response');
              imageUrl = URL.createObjectURL(blobResponse.data);
            }
          } catch (blobError) {
            console.log('❌ Blob fetch failed:', blobError);
          }
        }
      }
      
      console.log('🎯 Final imageUrl:', imageUrl);
      
      if (imageUrl) {
        dispatch(fetchBannerSuccess(positionID, imageUrl));
        return { success: true, imageUrl };
      } else {
        throw new Error('No valid image URL found in response');
      }
      
    } catch (error) {
      console.error(`❌ Error fetching banner for ${positionID}:`, error);
      dispatch(fetchBannerFailure(positionID, error.message));
      return { success: false, error: error.message };
    }
  };
};